import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { DevicePermission } from 'console/device/device_ts';
export function eligableDevice(account_id, device) {
    return (LegacyDevice.has_access(account_id, device, DevicePermission.view_state) &&
        LegacyDevice.supports_thermostat_ext_modes({
            device_type: device.device_type,
            thermostat_enabled: device.thermostat_enabled,
            capabilities: device.capabilities,
            firmware_version: device.firmware_version,
        }) &&
        (LegacyDevice.has_capability(device?.capabilities, Capability.has_thermostat) ||
            (LegacyDevice.has_capability(device?.capabilities, Capability.has_optional_thermostat) &&
                !!device.thermostat_enabled)));
}
export function isThermometerFailing(therm_info) {
    if (therm_info.last_state !== 'ok') {
        return true;
    }
    const value = therm_info.last_value;
    if (value == null) {
        return true;
    }
    return ((therm_info.limits?.high != null && value > therm_info.limits.high) ||
        (therm_info.limits?.low != null && value < therm_info.limits.low));
}
